// Mock Data für LIVAG Website

export const projects = [
  {
    id: 'bedastrasse-15',
    title: 'Bedastrasse 15',
    location: 'St. Gallen',
    address: 'Bedastrasse 15',
    status: 'Realisiert',
    type: 'Wohnen',
    units: '12 Wohneinheiten',
    year: '2022',
    image: 'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/3opgrsis_Bedastrasse15.jpg',
    description: 'Mit diesem Projekt entwickeln wir hochwertigen Wohnraum in attraktiver Lage. Die Architektur kombiniert zeitlose Eleganz mit effizienter Raumgestaltung und nachhaltigen Materialien. Ziel ist es, ein lebenswertes Zuhause für unterschiedliche Bedürfnisse zu schaffen.',
    gallery: [
      'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/3opgrsis_Bedastrasse15.jpg'
    ]
  },
  {
    id: 'faehnernstrasse-3',
    title: 'Fähnernstrasse 3',
    location: 'St. Gallen',
    address: 'Fähnernstrasse 3',
    status: 'Realisiert',
    type: 'Wohnen',
    units: '8 Wohneinheiten',
    year: '2021',
    image: 'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/r2rdwqoe_SG_F%C3%A4hnernstrasse%203_1.jpg',
    description: 'Mit diesem Projekt entwickeln wir hochwertigen Wohnraum in attraktiver Lage. Die Architektur kombiniert zeitlose Eleganz mit effizienter Raumgestaltung und nachhaltigen Materialien. Ziel ist es, ein lebenswertes Zuhause für unterschiedliche Bedürfnisse zu schaffen.',
    gallery: [
      'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/r2rdwqoe_SG_F%C3%A4hnernstrasse%203_1.jpg'
    ]
  },
  {
    id: 'st-jakobstrasse-52',
    title: 'St. Jakobstrasse 52',
    location: 'St. Gallen',
    address: 'St. Jakobstrasse 52',
    status: 'In Entwicklung',
    type: 'Wohnen',
    units: '14 Wohneinheiten',
    year: '2025',
    image: 'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/ya0825vb_St%20Gallen_St%20Jakobstrasse%2052_farbig.jpg',
    description: 'Mit diesem Projekt entwickeln wir hochwertigen Wohnraum in attraktiver Lage. Die Architektur kombiniert zeitlose Eleganz mit effizienter Raumgestaltung und nachhaltigen Materialien. Ziel ist es, ein lebenswertes Zuhause für unterschiedliche Bedürfnisse zu schaffen.',
    gallery: [
      'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/ya0825vb_St%20Gallen_St%20Jakobstrasse%2052_farbig.jpg'
    ]
  },
  {
    id: 'spittelerstrasse',
    title: 'Spittelerstrasse',
    location: 'St. Gallen',
    address: 'Spittelerstrasse',
    status: 'Verkauft',
    type: 'Wohnen',
    units: '6 Wohneinheiten',
    year: '2020',
    image: 'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/tuijw2qr_St.%20Gallen_Spittelerstrasse.jpg',
    description: 'Mit diesem Projekt entwickeln wir hochwertigen Wohnraum in attraktiver Lage. Die Architektur kombiniert zeitlose Eleganz mit effizienter Raumgestaltung und nachhaltigen Materialien. Ziel ist es, ein lebenswertes Zuhause für unterschiedliche Bedürfnisse zu schaffen.',
    gallery: [
      'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/tuijw2qr_St.%20Gallen_Spittelerstrasse.jpg'
    ]
  },
  {
    id: 'wilenhalde-herisau',
    title: 'Wilenhalde',
    location: 'Herisau',
    address: 'Wilenhalde',
    status: 'In Entwicklung',
    type: 'Wohnen & Gewerbe',
    units: '18 Wohneinheiten',
    year: '2026',
    image: 'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/gdrm8e0q_Herisau_Wilenhalde_farbig.png',
    description: 'Mit diesem Projekt entwickeln wir hochwertigen Wohnraum in attraktiver Lage. Die Architektur kombiniert zeitlose Eleganz mit effizienter Raumgestaltung und nachhaltigen Materialien. Ziel ist es, ein lebenswertes Zuhause für unterschiedliche Bedürfnisse zu schaffen.',
    gallery: [
      'https://customer-assets.emergentagent.com/job_eb9172b8-f224-4b6b-a2dc-b045c6adcb9e/artifacts/gdrm8e0q_Herisau_Wilenhalde_farbig.png'
    ]
  }
];

export const team = [
  {
    id: 1,
    name: 'Mic Kummer',
    position: 'Geschäftsführer',
    image: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/ocbk3ks8_Mic%20Kummer%20Hintergrund%20transparent.webp',
    bio: 'Experte für Projektentwicklung und strategische Planung mit langjähriger Erfahrung in der Ostschweizer Immobilienbranche.'
  },
  {
    id: 2,
    name: 'Christoph Jermann',
    position: 'Projektleiter',
    image: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/yprdkmz4_Christoph%20Jermann_Hintergrund%20transparent.webp',
    bio: 'Spezialist für Baumanagement und Qualitätssicherung mit Fokus auf nachhaltige Entwicklung.'
  }
];

export const companyInfo = {
  name: 'LIVAG AG',
  address: 'Katharinengasse 4',
  city: '9000 St. Gallen',
  phone: '071 226 11 99',
  email: 'info@livag.ch',
  website: 'www.livag.ch'
};

export const openingHours = [
  { day: 'Mo', hours: '09:00 – 17:00' },
  { day: 'Di', hours: '09:00 – 17:00' },
  { day: 'Mi', hours: '09:00 – 17:00' },
  { day: 'Do', hours: '09:00 – 17:00' },
  { day: 'Fr', hours: '09:00 – 17:00' },
  { day: 'Sa', hours: 'Geschlossen' },
  { day: 'So', hours: 'Geschlossen' }
];
